import {Component}             from '@angular/core';
import {ChartLogDaysComponent} from '../../lib/logr-charts/visualisations/chart-log-days/chart-log-days.component';
import {ChartVapeSumComponent} from '../../lib/logr-charts/visualisations/chart-vape-sum/chart-vape-sum.component';
import {UiCardComponent}       from '../../lib/logr-ui/comps/ui/ui-card/ui-card.component';

@Component({
			   selector   : 'app-view-days',
			   imports    : [
				   ChartLogDaysComponent,
				   UiCardComponent,
				   ChartVapeSumComponent
			   ],
			   templateUrl: './view-days.component.html',
			   styleUrl   : './view-days.component.css'
		   })
export class ViewDaysComponent {

}
